import React from 'react';
import { personalData } from '../data';

const About = () => {
  return (
    <section id="about" className="section">
      <h2 className="section-title">About Us</h2>
      <div className="section-content">
        <p>{personalData.executiveSummary}</p>
      </div>
    </section>
  );
};

export default About;
